import { getTenant, GXB, GXS } from '@/common/Tenants';
// eslint-disable-next-line import/no-named-as-default
import Service from '@/lib/App';

export const getShowPublisherFlag = (): boolean => {
  switch (getTenant()) {
    case GXS:
    case GXB:
      return Service.cache.isFeatureFlagOn('showPublisherGXS');
    default:
      return true;
  }
};
